<ng-container *ngIf="showPage">
  <div class="flex-all-center d-flex align-items-center justify-content-center flex-column vh100 px-3">
    <img src="../../../../assets/icons/Maintenance.svg" alt="maintenance" class="mb-5" />
    <h1>{{ 'SHARED.COMPONENTS.MAINTENANCE.TITLE' | translate }}</h1>
    <h2 class="text-center" [innerHTML]="'SHARED.COMPONENTS.MAINTENANCE.INFO' | translate: { email: email }"></h2>
  </div>
</ng-container>
